<button mat-raised-button class="secondary-1" (click)="file.click()">import</button>
{{name}}
<input type='file' (change)="fileChanged($event)" #file style="display:none">
